import { useEffect, useRef } from "react";
import { Head, useForm, usePage } from "@inertiajs/react";
import { LogIn } from "lucide-react";
import AuthShell from "@/components/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

/**
 * Where a sign-in link lands. Opening the link doesn't use it (mail
 * scanners open links too), so the page posts the token back as soon as
 * it loads. The button is there if that doesn't go through.
 */
export default function ConfirmSignIn({ email, token, confirm_path }) {
  const { routes } = usePage().props;
  const { post, processing } = useForm({ token });
  const sent = useRef(false);

  useEffect(() => {
    // React's dev double-run would otherwise post twice.
    if (sent.current) return;
    sent.current = true;
    post(confirm_path);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    post(confirm_path);
  };

  return (
    <AuthShell helpHref={routes.help}>
      <Head title="Signing in" />
      <Card>
        <CardHeader className="text-center">
          <CardTitle as="h1">Signing you in…</CardTitle>
          <CardDescription>
            as <span className="font-medium text-foreground">{email}</span>
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit}>
            <Button type="submit" className="w-full" disabled={processing}>
              <LogIn className="h-4 w-4" />
              Sign in
            </Button>
          </form>
        </CardContent>
      </Card>
    </AuthShell>
  );
}
